module.exports = "https://cdn.hellotech.com/client-assets/HT-guarantee_bf3841bddd031acd41aa93ee5cb10796.svg";